import React from 'react';
import { Search, MapPin, UserPlus, FileText, ArrowRight } from 'lucide-react';

const MarketingWorkflow = () => {
  const steps = [
    {
      number: "1",
      icon: <Search className="w-5 h-5 text-[#2DD4BF]" />,
      title: "Spot & Scan",
      description: "Arrive at a potential store and hit the 'Nearby' button. The app instantly scans a 250m radius to see if the store is already in your database."
    },
    {
      number: "2",
      icon: <MapPin className="w-5 h-5 text-[#2DD4BF]" />,
      title: "Identify Lead",
      description: "If the store appears, instantly view past notes and history. If not, you've found a fresh prospect ready for the system."
    },
    {
      number: "3",
      icon: <UserPlus className="w-5 h-5 text-[#2DD4BF]" />,
      title: "Quick Add",
      description: "Found a new shop? Tap 'Use Current Location' to auto-fill the address and GPS coordinates. No typing, no errors, just one tap."
    },
    {
      number: "4",
      icon: <FileText className="w-5 h-5 text-[#2DD4BF]" />,
      title: "Market Mode",
      description: "Start a session as 'InProgress'. Record notes and build the relationship until they are ready for their first order. Any store can be added to a Follow-up route for instant access."
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-black text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header - Adjusted font sizes for mobile */}
        <div className="text-center mb-12 md:mb-20">
          <span className="bg-[#2DD4BF] text-black text-[10px] font-bold px-3 py-1 uppercase tracking-widest rounded-sm">
            The Marketing Workflow
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mt-6 mb-2 leading-tight">From Scouting to Lead.</h2>
          <h3 className="text-3xl md:text-5xl font-bold text-gray-600">Four Simple Steps.</h3>
        </div>

        {/* Steps Grid - grid-cols-1 by default for iPhone */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-4 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              <div className="bg-[#111111] border border-white/5 p-6 md:p-8 h-full rounded-sm flex flex-col transition-colors hover:border-[#2DD4BF]/30">
                {/* Number and Line */}
                <div className="flex items-center mb-6 md:mb-8">
                  <div className="bg-[#2DD4BF] text-black w-10 h-10 flex-shrink-0 flex items-center justify-center font-bold text-lg">
                    {step.number}
                  </div>
                  <div className="flex-grow h-[1px] bg-gray-800 ml-4"></div>
                </div>

                {/* Icon Box */}
                <div className="bg-white/5 w-12 h-12 flex items-center justify-center mb-6 border border-white/10 rounded-sm">
                  {step.icon}
                </div>

                {/* Content */}
                <h4 className="text-xl md:text-2xl font-bold mb-3 md:mb-4 text-white">{step.title}</h4>
                <p className="text-gray-400 leading-relaxed text-sm md:text-base">
                  {step.description}
                </p>
              </div>

              {/* Connecting Arrow - Strictly Desktop Only */}
              {index < steps.length - 1 && (
                <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 z-10 bg-[#111111] border border-white/10 p-1 rounded-sm">
                  <ArrowRight className="w-4 h-4 text-[#2DD4BF]" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketingWorkflow;